import React from "react";
import ThemeToggle from "./ui/ThemeToggle";
import { useTheme } from "../context/ThemeContext";

/** Shared frame for login and company selection: logo, panel, theme toggle. */
export default function AuthLayout({ children }) {
  const { darkMode } = useTheme();

  return (
    <div className="flex min-h-dvh flex-col items-center bg-slate-100 px-4 py-4 dark:bg-slate-950">
      <div className="flex w-full max-w-[400px] justify-end">
        <ThemeToggle />
      </div>

      <main className="flex w-full flex-1 flex-col items-center justify-center pb-16">
        <img src={darkMode ? "/logo-light.png" : "/logo-dark.png"} alt="Logik" className="mb-6 h-8 w-auto" />
        <div className="w-full max-w-[400px] rounded-xl border border-slate-200 bg-surface p-6 shadow-card dark:border-slate-800 dark:bg-slate-900 dark:shadow-card-dark">
          {children}
        </div>
      </main>
    </div>
  );
}
